
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import PaginaInformativa, { Sezione } from '../components/PaginaInformativa';
Termini.paginaPubblica = true;
export default function Termini() {
    return (<PaginaInformativa titolo="Termini d'uso" sottotitolo="Condizioni per l'utilizzo dell'ambiente dimostrativo." aggiornamento="6 agosto 2026">
      <p>
        Dimora è un ambiente dimostrativo di Giuseppe Delli Paoli: serve a
        mostrare il funzionamento di un gestionale per locazioni immobiliari.
        Non è un servizio commerciale e l&apos;uso della demo non costituisce
        un rapporto contrattuale.
      </p>

      <Sezione titolo="Uso della demo">
        <p>
          Puoi esplorare la demo liberamente e modificare i dati di esempio.
          L&apos;ambiente è condiviso: i dati possono essere ripristinati in
          qualsiasi momento e senza preavviso. Non caricare dati personali
          reali, contenuti illeciti o materiale di cui non possiedi i diritti.
        </p>
      </Sezione>

      <Sezione titolo="Nessuna garanzia">
        <p>
          La demo è fornita &laquo;così com&apos;è&raquo;, senza garanzie di
          disponibilità, correttezza o conservazione dei dati. Nessun
          documento generato dalla demo (ricevute, contratti, esportazioni)
          ha valore legale o fiscale.
        </p>
      </Sezione>

      <Sezione titolo="Software e licenza">
        <p>
          Dimora deriva dal progetto open source microrealestate, distribuito
          con licenza MIT. Le note di attribuzione complete sono incluse nel
          codice sorgente del progetto.
        </p>
      </Sezione>
    </PaginaInformativa>);
}

    async function __Next_Translate__getStaticProps__19fd5e3c6af__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/termini',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19fd5e3c6af__ as getStaticProps }
  